import React, { Component } from 'react';
import {
  View,
  StyleSheet,
  SafeAreaView,
  Image,
  TouchableOpacity,
  Dimensions,
  Alert,
  Platform,
  ActivityIndicator
} from 'react-native';
import Label from '../components/Label'
import TextBox from '../components/textbox';
import { createStyles, maxWidth } from 'react-native-media-queries';
import { Color } from '../utils/color';
import { Constants } from '../utils/constants';

import { StdAlert } from './../components/Alert.web'
import { isSamePassword } from '../utils/validation';
import { Analytics } from '../components/Analytics';
//robert.pars@mailinator.com
//Robert@123
export default class ResetPassword extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      newPassword: "",
      confirmPassword: "",
      isLoadning: false,
      originalWidth: Dimensions.get("window").width,
      token: this.props.navigation.state.params.token || ""

    }
  }

  componentDidMount() {
    // console.log("===== token ===", this.props.navigation.state.params.token)
  }

  handleText = (name) => {
    return (text) => {
      this.setState({ [name]: text.replace(/\s/g, '') })
    }
  }

  validation = () => {
    var message = "";

    if (this.state.newPassword.length == 0) {
      message = "Please enter a Password"
    } else if (this.state.newPassword.length < 8) {
      message = "Password length must be between 8 and 128"
    } else if (this.state.confirmPassword < 8) {
      message = "Confirm Password length must be between 8 and 128"
    } else if (!isSamePassword(this.state.confirmPassword, this.state.newPassword)) {
      message = "Password & confirm Password doesn't match"
    }

    return message;

  }

  resetPasswordAPI = async () => {

    let messageAlert = this.validation()

    if (messageAlert.length > 0) {
      const alertTitle = 'CXSphere'
      const alertText = messageAlert
      if (Platform.OS === 'web') {
        StdAlert(alertTitle, alertText, () => {
          console.log('OK Pressed');
        })
      } else {

        Alert.alert(
          alertTitle,
          alertText,
          [
            { text: 'OK', onPress: () => console.log('OK Pressed') },
          ],
          { cancelable: false },
        );
      }
      return;
    }

    this.setState({
      isLoadning: true
    })

    try {

      let url = `${Constants.BASE_URL}${Constants.RESET_PASSWORD}`
      let response = await fetch(url, {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          "password": this.state.newPassword,
          "confirmPassword": this.state.confirmPassword,
          "resetToken": this.state.token

        }),
      });


      this.setState({
        isLoadning: false
      })

      if (response.ok) {
        let responseJson = await response.json();

        if (responseJson && responseJson.code == "Success") {

          if (Platform.OS === 'web') {
            StdAlert('CXSphere', responseJson.message, () => {
              this.props.navigation.navigate("LoginScreen")
            })
          } else {
            Alert.alert(
              'CXSphere',
              responseJson.message,
              [
                {
                  text: 'OK', onPress: () => {
                    this.props.navigation.navigate("LoginScreen")
                  }
                },
              ],
              { cancelable: false },
            );
          }

        } else {
          if (Platform.OS === 'web') {
            alert(responseJson.message)
          } else {
            Alert.alert("CXSphere", responseJson.message)
          }
        }

      } else {
        alert("User is not found");
      }

    } catch (error) {
      this.setState({
        isLoadning: false
      })
    }

  }

  _handleLayout = ({ nativeEvent }) => {
    const { width } = nativeEvent.layout;
    this.setState({
      originalWidth: width
    })
    this.setState(() => ({ isWide: width >= 991 }));
  };


  render() {
    return (
      <SafeAreaView onLayout={this._handleLayout} style={{ flex: 1 }}>
        <Analytics />
        <View style={[styles.Container, { backgroundColor: this.state.originalWidth > 991 ? Color.WhiteLight : Color.White }]}>
          {this.state.originalWidth > 991 && <View style={{
            width: '100%',
            backgroundColor: Color.White,
            paddingTop: 15,
            paddingBottom: 15,
            paddingLeft: '10%',
          }}>
            <Image style={styles.welcomeImage} source={require("../assets/images/logo.png")} />
          </View>}
          {this.state.originalWidth < 991 && <View style={styles.mobileHeader}>
            <Image style={styles.welcomeImage} source={require("../assets/images/logo.png")} />
          </View>}

          <Label Barlow_SemiBold style={[styles.title, { display: (this.state.originalWidth < 991 ? 'none' : 'flex'), alignSelf: 'center', }]}>Reset Password</Label>
          <View style={styles.boxRow}>
            <View style={[styles.login, { paddingTop: (this.state.originalWidth < 991 ? 20 : 0) }]}>


              <TextBox
                textStyle={{ backgroundColor: Color.White }}
                secureTextEntry={true}
                onChangeText={this.handleText("newPassword")}
                placeholder="New Password" />

              <TextBox
                textStyle={{ backgroundColor: Color.White }}
                secureTextEntry={true}
                onChangeText={this.handleText("confirmPassword")}
                onSubmitEditing={() => {
                  //this.forgotPasswordAPI()
                }}
                placeholder="Confirm Password" />

              <TouchableOpacity onPress={this.resetPasswordAPI} style={styles.button} >
                {!this.state.isLoadning && <Label style={{ fontSize: 14 }} Barlow_Regular color={Color.White}>Send</Label>}
                {this.state.isLoadning && <ActivityIndicator size="small" color="white" />}
              </TouchableOpacity>
            </View>
          </View>
        </View>

      </SafeAreaView >
    );
  }

}

ResetPassword.navigationOptions = {
  header: null,
};
const base = StyleSheet.create({
  Container: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'flex-start',
  },
  mobileHeader: {
    paddingTop: (Platform.OS == 'ios' ? 20 : 40),
    paddingBottom: 20,
    width: '100%',
    justifyContent: 'center',
    alignItems: "center"
  },
  logoDesktop: {
    width: '100%',
    backgroundColor: Color.White,
    paddingTop: 20,
    paddingBottom: 20,
    paddingLeft: '10%',
  },
  logoImgMobile: {
    display: 'none',
  },

  button: {
    alignItems: 'center',
    justifyContent: "center",
    backgroundColor: '#005961',
    borderRadius: 5,
    marginTop: 5,
    marginBottom: 10,
    height: 45,
  },
  BackBtn: {
    marginTop: 25,
    flexDirection: 'row',
    alignItems: "center",
  },
  welcomeImage: {
    width: 100,
    height: 80,
    resizeMode: 'contain',
  },
  login: {
    width: 400,
    paddingLeft: 0,
    marginLeft: 'auto',
  },
  title: {
    fontSize: 36,
    color: Color.DarkGreen,
    textAlign: 'center',
    marginBottom: 50,
    marginTop: 50,
  },
  boxRow: {
    alignItems: 'center',
  },

});

const styles = createStyles(
  base,
  maxWidth(1024, {
    logoDesktop: {
      width: '100%',
      backgroundColor: Color.White,
      paddingTop: 15,
      paddingBottom: 15,
      paddingLeft: '10%',
    },
    title: {
      fontSize: 30,
      color: Color.DarkGreen,
      textAlign: 'center',
      marginBottom: 32,
    },

  }),

  maxWidth(991, {

    logoImgMobile: {
      alignItems: 'center',
      paddingBottom: 25,
      paddingTop: 50,
    },
    title: {
      // display: 'none',
    },
    login: {
      width: Dimensions.get("window").width - 30,
      paddingLeft: 0,
      marginLeft: 'auto',
      marginRight: 'auto',
    },
  })
);